/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import {
  Card,
  Typography,
  Grid,
  Button,
  TextField,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Radio,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { Edit } from '@material-ui/icons';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { updateSettings, fetchSettings } from '../../services/killshot';
import KSOrganizations from './components/KSOrganizations';
import store from '../../redux/store';

const Container = styled.div`
  padding: 25px;
`;

const Table = styled.table`
  position: relative;
  margin: 10px auto;
  width: 100%;
  height: auto;
  border-collapse: collapse;
`;

const Tr = styled.tr`
  border-bottom: 1px solid #b9a4bc;
  height: 45px;
`;

const Td = styled.td`
  display: flex;
`;

const useStyles = makeStyles({
  root: {
    padding: 15,
  },
  gridContainerRoot: {
    flexGrow: 1,
    padding: 15,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

function Settings() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [sgLoading, setSGLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [sgEdit, setSGEdit] = useState(false);
  const [initialTndListPrice, setInitialTndListPrice] = useState(0);
  const [tndListPrice, setTndListPrice] = useState(0);
  const [MarketListingID, setMarketListingID] = useState(0);
  const [initialSGListPrice, setInitialSGListPrice] = useState(0);
  const [sgListPrice, setSGListPrice] = useState(0);
  const [incrementSymbol, setSymbol] = useState('+');
  const [incrementSGSymbol, setSGSymbol] = useState('+');

  const setSymbolHandler = (event, value) => {
    if (tndListPrice === 0) {
      setSymbol('+');
    } else {
      const newValue = value !== null ? value : incrementSymbol;
      setSymbol(newValue);
      if (newValue !== incrementSymbol) setTndListPrice(tndListPrice * -1);
    }
  };

  const setSGSymbolHandler = (event, value) => {
    if (sgListPrice === 0) {
      setSGSymbol('+');
    } else {
      const newValue = value !== null ? value : incrementSGSymbol;
      setSGSymbol(newValue);
      if (newValue !== incrementSGSymbol) setSGListPrice(sgListPrice * -1);
    }
  };

  const handleEdit = () => {
    setEdit(true);
    if (initialTndListPrice < 0) {
      setSymbol('-');
    }
  };

  const handleSGEdit = () => {
    setSGEdit(true);
    if (initialSGListPrice < 0) {
      setSGSymbol('-');
    }
  };

  const handleTndListPrice = e => {
    let integerPart = '';
    let decimalPart = '';
    if (e.target.value.includes('.')) {
      [integerPart, decimalPart] = e.target.value.split('.');
    } else {
      integerPart = e.target.value;
      decimalPart = '';
    }
    if (integerPart.length < 5 && decimalPart.length < 3) {
      setTndListPrice(Number(e.target.value));
    }
    if (e.target.value.includes('-')) {
      setSymbol('-');
    }
    if (!e.target.value.includes('-')) {
      setSymbol('+');
    }
    if (e.target.value.length === 0) {
      setSymbol('+');
    }
  };

  const handleSGListPrice = e => {
    let integerPart = '';
    let decimalPart = '';
    if (e.target.value.includes('.')) {
      [integerPart, decimalPart] = e.target.value.split('.');
    } else {
      integerPart = e.target.value;
      decimalPart = '';
    }
    if (integerPart.length < 5 && decimalPart.length < 3) {
      setSGListPrice(Number(e.target.value));
    }
    if (e.target.value.includes('-')) {
      setSGSymbol('-');
    }
    if (!e.target.value.includes('-')) {
      setSGSymbol('+');
    }
    if (e.target.value.length === 0) {
      setSGSymbol('+');
    }
  };

  const handleClose = () => {
    setEdit(false);
    setTndListPrice(initialTndListPrice);
    setSymbol(initialTndListPrice >= 0 ? '+' : '-');
  };

  const handleSGClose = () => {
    setSGEdit(false);
    setSGListPrice(initialSGListPrice);
    setSGSymbol(initialSGListPrice >= 0 ? '+' : '-');
  };

  const handleSubmit = async () => {
    setLoading(true);
    await updateSettings(tndListPrice, 'tnd_list_price_adjustment');
    setInitialTndListPrice(tndListPrice);
    setLoading(false);
    setEdit(false);
  };

  const handleMarketListingID = async event => {
    setMarketListingID(event.target.value);
    await updateSettings(event.target.value, 'marketplace_listing_id');
  };
  const handleSGSubmit = async () => {
    setSGLoading(true);
    await updateSettings(sgListPrice, 'sg_list_price_adjustment');
    setInitialSGListPrice(sgListPrice);
    setSGLoading(false);
    setSGEdit(false);
  };

  const fetchData = async () => {
    const response = await fetchSettings();
    setTndListPrice(response.tnd_list_price_adjustment);
    setInitialTndListPrice(response.tnd_list_price_adjustment);
    setMarketListingID(response.marketplace_listing_id);
    setSGListPrice(response.sg_list_price_adjustment);
    setInitialSGListPrice(response.sg_list_price_adjustment);
    setSymbol(response.tnd_list_price_adjustment >= 0 ? '+' : '-');
  };

  const useFetch = () => {
    useEffect(() => {
      fetchData();
    }, []);
  };

  const { user } = store.getState();

  useFetch();

  return (
    <Container>
      <Typography variant="h3" gutterBottom>
        Admin Settings
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <Typography variant="h6" gutterBottom>
              Global List Price Adjustment
            </Typography>
            <div className={classes.gridContainerRoot}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Table>
                    <Tr>
                      <td>
                        <Typography>Market</Typography>
                      </td>
                      <td>
                        <Typography>Mark-up</Typography>
                      </td>
                      <td />
                    </Tr>
                    <Tr>
                      <td>
                        <Typography>TND List Price Adjusment</Typography>
                      </td>
                      <Td>
                        {!edit && <Typography style={{ marginTop: 10 }}>{tndListPrice.toFixed(2)}%</Typography>}
                        {edit && (
                          <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: 5 }}>
                              <ToggleButtonGroup
                                value={incrementSymbol}
                                style={{ marginTop: '15px' }}
                                exclusive
                                onChange={(e, value) => {
                                  e.persist();
                                  setSymbolHandler(e, value);
                                }}
                              >
                                <ToggleButton value="+" style={{ width: 14, height: 26 }}>
                                  +
                                </ToggleButton>
                                <ToggleButton value="-" style={{ width: 14, height: 26 }}>
                                  -
                                </ToggleButton>
                              </ToggleButtonGroup>
                            </div>
                            <TextField
                              label=""
                              value={tndListPrice}
                              onChange={handleTndListPrice}
                              type="number"
                              fullWidth
                              inputProps={{ step: 0.1 }}
                              style={{ width: 65, marginTop: 10 }}
                            />
                          </div>
                        )}
                      </Td>
                      {!edit && (
                        <td>
                          <Button
                            onClick={handleEdit}
                            startIcon={<Edit />}
                            size="small"
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                        </td>
                      )}
                      {edit && (
                        <td>
                          <Button
                            disabled={loading}
                            onClick={handleClose}
                            size="small"
                            variant="contained"
                            style={{ marginRight: 10 }}
                          >
                            Cancel
                          </Button>
                          <Button
                            disabled={loading}
                            onClick={handleSubmit}
                            size="small"
                            variant="contained"
                            color="primary"
                          >
                            Save
                            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                          </Button>
                        </td>
                      )}
                    </Tr>
                    <Tr>
                      <td>
                        <Typography>SG List Price Adjusment</Typography>
                      </td>
                      <Td>
                        {!sgEdit && <Typography style={{ marginTop: 10 }}>{sgListPrice.toFixed(2)}%</Typography>}
                        {sgEdit && (
                          <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: 5 }}>
                              <ToggleButtonGroup
                                value={incrementSGSymbol}
                                style={{ marginTop: '15px' }}
                                exclusive
                                onChange={(e, value) => {
                                  e.persist();
                                  setSGSymbolHandler(e, value);
                                }}
                              >
                                <ToggleButton value="+" style={{ width: 14, height: 26 }}>
                                  +
                                </ToggleButton>
                                <ToggleButton value="-" style={{ width: 14, height: 26 }}>
                                  -
                                </ToggleButton>
                              </ToggleButtonGroup>
                            </div>
                            <TextField
                              label=""
                              value={sgListPrice}
                              onChange={handleSGListPrice}
                              type="number"
                              fullWidth
                              inputProps={{ step: 0.1 }}
                              style={{ width: 65, marginTop: 10 }}
                            />
                          </div>
                        )}
                      </Td>
                      {!sgEdit && (
                        <td>
                          <Button
                            onClick={handleSGEdit}
                            startIcon={<Edit />}
                            size="small"
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                        </td>
                      )}
                      {sgEdit && (
                        <td>
                          <Button
                            disabled={sgLoading}
                            onClick={handleSGClose}
                            size="small"
                            variant="contained"
                            style={{ marginRight: 10 }}
                          >
                            Cancel
                          </Button>
                          <Button
                            disabled={sgLoading}
                            onClick={handleSGSubmit}
                            size="small"
                            variant="contained"
                            color="primary"
                          >
                            Save
                            {sgLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                          </Button>
                        </td>
                      )}
                    </Tr>
                  </Table>
                </Grid>
                <Grid item xs={6} />
              </Grid>
            </div>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <Typography variant="h6" gutterBottom>
              Marketplace Listings ID
            </Typography>
            <div className={classes.gridContainerRoot}>
              <Grid container spacing={3}>
                {!edit && (
                  <FormControl>
                    <RadioGroup row color="primary" value={MarketListingID} onChange={handleMarketListingID}>
                      <FormControlLabel
                        value="SkyBox Listing ID"
                        control={<Radio color="primary" />}
                        label="SkyBox Listing ID"
                      />
                      <FormControlLabel value="Broker ID" control={<Radio color="primary" />} label="Broker ID" />
                    </RadioGroup>
                  </FormControl>
                )}
              </Grid>
            </div>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <Typography variant="h6" gutterBottom>
              KS Organizations
            </Typography>
            <div className={classes.gridContainerRoot}>
              <KSOrganizations ksOrgs={(user && user.organizations) || []} />
            </div>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Settings;
